import {
  FormControl,
  FormGroup,
  FormLabel,
  Typography,
  useTheme,
} from "@mui/material";
import { BaseCheckbox } from "../base-checkbox";

type BaseCheckboxGroupProps<TKeys extends string> = {
  label?: string;
  options: {
    key: TKeys;
    label: string;
  }[];
  selectedValues: TKeys[];
  error?: boolean;
  helperText?: string;
  onChange: (selectedValues: TKeys[]) => void;
  onBlur?: () => void;
};
export function BaseCheckboxGroup<T extends string>({
  label,
  options,
  selectedValues,
  error,
  helperText,
  onChange,
  onBlur,
}: BaseCheckboxGroupProps<T>) {
  const theme = useTheme();
  const handleCheckboxChange = (key: T) => {
    const newSelectedValues = selectedValues.includes(key)
      ? selectedValues.filter((value) => value !== key)
      : [...selectedValues, key];
    onChange(newSelectedValues);
  };

  return (
    <FormControl component="fieldset">
      <FormLabel sx={{ marginBottom: "4px" }}>{label}</FormLabel>
      <FormGroup row sx={{ gap: "8px" }}>
        {options.map((option) => (
          <BaseCheckbox
            key={option.key}
            label={option.label}
            value={selectedValues.includes(option.key)}
            onChange={() => handleCheckboxChange(option.key)}
            onBlur={onBlur}
            error={error}
          />
        ))}
      </FormGroup>
      <Typography
        variant="body2"
        mt="4px"
        sx={{
          color: error ? theme.palette.caution[500] : theme.palette.grey[500],
        }}
      >
        {helperText}
      </Typography>
    </FormControl>
  );
}
